"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeatherShowOption')(function selectWeatherShowOption(weatherEnabled, state) {
    var optionState = state.optionState;
    optionState.weatherEnabled = weatherEnabled;
}));
//# sourceMappingURL=selectWeatherShowOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/actions/selectWeatherShowOption.js
// module id = 5256
// module chunks = 2